export const NAV_CATEGORIES = [
  'print-sets',
  'wall-art',
  'desk',
  'photo-books',
  'calendars',
  'display',
  'gifts',
];

export const SHOP_CATEGORIES = [
  'print-sets',
  'wall-art',
  'photo-books',
  'calendars',
  'display',
  'gifts',
];

export const FAVORITE_PRODUCTS = [
  'square-prints',
  'engineer-prints',
  'softcover-books',
  'news-print',
  'wall-calendar',
  'artprint',
];

export const FAVORITE_CATEGORIES = ['photo-books', 'display', 'print-sets', 'wall-art'];

export const NEW_PRODUCTS = [
  'acrylic-prints',
  'framed-art-prints',
  // 'custom-photo-greeting-cards',
  'custom-photo-holiday-cards',
  'metal-wall-prints',
];

export const MIGHT_LIKE_PRODUCTS = [
  'metal-desk-prints',
  'metal-wall-prints',
  'square-prints',
  'engineer-prints',
  'artprint',
  'softcover-books',
  'classic-prints',
  'news-print',
  'framed-prints',
  'square-engineer-prints',
  'wall-calendar-large',
  'engineer-print-calendar',
];

export const HOLIDAY_CARDS_CATEGORIES = [
  'Christmas',
  'Hanukkah',
  'Holiday',
  'New Year',
  'Upload Your Own',
];

export const GREETING_CARDS_CATEGORIES = [
  'Birth Announcement',
  'Hello',
  'Other',
  'Save the Date',
  'Thank You',
  'Upload Custom',
];
